import type { UseQueryResult } from '@tanstack/react-query';
import { StorageKey } from './model/StorageKey';
import { useLocalStorage } from './useLocalStorage';
import type { OrderAddress } from '../bff-api/baskets/model';

export const useSDDAddress = (): UseQueryResult<OrderAddress | undefined> =>
    useLocalStorage<OrderAddress | undefined>(StorageKey.SDD_ADDRESS);
